module.exports = {
      id: "line-arrow-prev-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#line-arrow-prev",
      toString: function () {
        return this.url;
      }
    }